var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 27.3334H9.33341C5.33341 27.3334 2.66675 25.3334 2.66675 20.6668V11.3334C2.66675 6.66678 5.33341 4.66678 9.33341 4.66678H22.6667C26.6667 4.66678 29.3334 6.66678 29.3334 11.3334V20.6668C29.3334 25.3334 26.6667 27.3334 22.6667 27.3334Z",
    stroke: "#FF8200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 12.0001L18.4932 15.3335C17.1199 16.4268 14.8666 16.4268 13.4932 15.3335L9.33325 12.0001",
    stroke: "#FF8200",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.118927e05ca8d99a4af5a6ba6e9a9842.svg";
export { ForwardRef as ReactComponent };